/**
 * Retourne le status code
 * @param {object} param0
 * @param {object} param0.error
 * @return {number}
 */
export default function getErrorStatus({ error }) {
  return error?.body?.errors?.[0]?.status;
}
